import React from "react";
import { Box, Container, Grid, Skeleton, Typography } from "@mui/material";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Hero from "./Hero";
import Info from "./Info";
import { useLabDetails } from "../../hooks/useLab";

function LabDetails() {
    const { lab, loading, error } = useLabDetails();

    return (
        <Box>
            <Header />

            {/* Main Content Area */}
            <Box sx={{ minHeight: "85vh" }}>
                {loading ? (
                    <Container sx={{ py: 4 }}>
                        {/* Hero Skeleton */}
                        <Grid container spacing={4} sx={{ mb: 4 }}>
                            <Grid item xs={12} md={9}>
                                <Skeleton height={36} width="100px" sx={{ mb: 1 }} />
                                <Skeleton variant="text" height={40} width="60%" sx={{ mb: 1 }} />
                                <Skeleton variant="text" height={20} width="90%" sx={{ mb: 1 }} />
                                <Skeleton variant="text" height={20} width="80%" sx={{ mb: 2 }} />
                                <Skeleton variant="rectangular" height={48} width="200px" sx={{ borderRadius: 2 }} />
                            </Grid>
                        </Grid>

                        {/* Info Skeleton */}
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <Skeleton variant="rectangular" height={300} sx={{ borderRadius: 2 }} />
                            </Grid>
                        </Grid>
                    </Container>
                ) : error ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '50vh',
                            textAlign: 'center',
                            px: 2,
                        }}
                    >
                        <Typography variant="h6" color="error">
                            {error}
                        </Typography>
                    </Box>
                ) : lab ? (
                    <>
                        <Hero lab={lab} />
                        <Info lab={lab} />
                    </>
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '60vh',
                            textAlign: 'center',
                            px: 2,
                        }}
                    >
                        <Typography variant="h5" sx={{ mb: 1, color: 'text.primary', fontWeight: 600 }}>
                            No lab found
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 400 }}>
                            We couldn't find a lab matching your request. Please check the URL or try browsing available labs.
                        </Typography>
                    </Box>
                )}
            </Box>

            <Footer />
        </Box>
    );
}

export default LabDetails;
